import { render, staticRenderFns } from "./DeviceMenu.vue?vue&type=template&id=0cdb698b&scoped=true"
import script from "./DeviceMenu.vue?vue&type=script&lang=js"
export * from "./DeviceMenu.vue?vue&type=script&lang=js"
import style0 from "./DeviceMenu.vue?vue&type=style&index=0&id=0cdb698b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdb698b",
  null
  
)

export default component.exports